import React from 'react';
import Button from '../../components/button/button.jsx';
import './cta.scss'

const Cta = ({data}) => {
	return 	<div className="component cta">
				<div className="inner">
					<p>{data.text}</p>
					<Button icon={data.button.icon} text={data.button.text} clickEvent={data.button.clickEvent}/>;
				</div>
			</div>
}

export default Cta;


// WEBPACK FOOTER //
// ./src/blocks/cta/cta.jsx